'use client';

import { FC, useEffect } from 'react';
import logoutObserver from '@/observers/LogoutObserver';
import { withNoSSR } from '@/components/NoSSR';
import { usePrepareAESKey } from './hooks/usePrepareAESKey';
import { useGetUserStatus } from '@/userStatus/hooks';
import { removeEncryptorStorageData } from './utils/storage';

export const PrepareEncryptionContainer: FC = withNoSSR(() => {
  const { prepareAESKey } = usePrepareAESKey();

  const { isVerified } = useGetUserStatus();

  useEffect(() => {
    if (isVerified) prepareAESKey();

    const unsubscribeLogout = logoutObserver.subscribe(
      removeEncryptorStorageData
    );

    return unsubscribeLogout;
  }, [isVerified]);

  return <></>;
});
